export class CardModel {
  constructor(suit, value) {
    this.suit = suit;
    this.value = value;
  }
}
